<template>
  <div class="webWrap" id="home">
    <div class="top_box">
      <div class="top_nav">
        <span class="logo"></span>
        <a href="#home">首页</a>
        <a href="#tleBox">专栏</a>
        <a href="#contactUs">关于</a>
      </div>
    </div>
    <div class="content_box">
      <div class="con_tle">推读</div>
      <ul class="con_lists">
        <li>
          <a href="javascript:;">
            <img src="https://shp.qpic.cn/cfwebcap/0/dd4b0561eb8ec68bd8b0b2077212e3a1/0?width=900&height=383" alt="">
            <h3>《闹闹天宫》2020年4月23日更新公告</h3>
            <p>《闹闹天宫》预计将于4月23日上午08:00-11:00进行不停机更新，更新过程中可能出现暂时无法匹配的情况，已匹配成功的玩家不受影响，更新完毕后重新登录即可获取更新内容。</p>
          </a>
        </li>
        <li>
          <a href="javascript:;">
            <img src="http://img.linekong.com/s_edt/2017/09/11/n181000002579679.jpg" alt="">
            <h3>我的青春时代感谢有你《黎明之光》周年庆</h3>
            <p>最好的青春年华献给最火的你，蓝港互动旗下3D魔幻RPG手游《黎明之光》即将迎来盛大周年庆典，全新“青春时代”服装，海量超值福利，全民狂欢，这是属于洛亚大陆冒险者的难忘金秋!《黎明之光》周年庆感谢有你一路相随!</p>
          </a>
        </li>
        <li>
          <a href="javascript:;">
            <img src="http://img.linekong.com/lk_edt/2019/01/30/n171000004332812.jpg" alt="">
            <h3>蓝港互动《我与你的光年距离2》收官，“小而美”爱情剧再度告捷</h3>
            <p>“意料之外的好看”，在《我与你的光年距离2》豆瓣评论区里，不少观众不吝赞美之词。</p>
          </a>
        </li>
        <li>
          <a href="javascript:;">
            <img src="http://img.linekong.com/lk_edt/2018/07/18/n141000004250580.jpg" alt="">
            <h3>蓝港互动员工手册CEO寄语曝光：刻下你的名字</h3>
            <p>蓝港互动集团CEO廖明香在员工手册上对新入职的员工写下了内部寄语——《刻下你的名字》，以下为CEO寄语的全文曝光</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="content_box column_box" id="tleBox">
      <div class="con_tle">专栏</div>
      <ul class="con_lists">
        <li>
          <a href="javascript:;">
            <img src="//game.gtimg.cn/images/nntgjgyx/web201812/pc/img/guide_img.jpg" alt="">
            <h3>《闹闹天宫》游戏介绍</h3>
            <p>《闹闹天宫》是由蓝港互动研发、腾讯极光计划发行的横版国风4V4轻竞技手游。充满挑战的MOBA竞技+轻松趣味的io对战，数十位神话英雄超多战斗搭配，给你带来全新的游戏体验！正面硬刚或是猥琐偷袭，群追猛打还是避战骚扰，打法随心放肆浪，生死转瞬秒翻盘！在这里，天宫争夺，一触即发，来感受动画般生动有趣的竞技游戏，打造属于你的盖世英雄吧！</p>
          </a>
        </li>
        <li>
          <a href="javascript:;">
            <img src="http://img.linekong.com/s/2017/06/23/n111000001889473.jpg" alt="">
            <h3>蓝港游戏全国哀悼日停服公告</h3>
            <p>为表达全国各族人民对抗击新冠肺炎疫情斗争中牺牲烈士和逝世同胞的深切哀悼，积极响应国务院发布的2020年4月4日全国性哀悼活动，蓝港互动决定4月4日0:00-24:00暂停旗下所有游戏的运营，感谢大家的理解与支持。</p>
          </a>
        </li>
        <li>
          <a href="javascript:;">
            <img src="http://img.linekong.com/lk_edt/2018/12/14/n171000004309716.jpg" alt="">
            <h3>蓝港互动《黎明之光》摘获游戏领域年度最佳海外发行奖</h3>
            <p>12月13日，由多牛传媒主办的2018第九届互联网牛耳文娱盛典在北京演艺中心召开。大会中，蓝港互动手游《黎明之光》(Daybreak  Legends)摘获2018年游戏领域年度最佳海外发行奖。</p>
          </a>
        </li>
        <li>
          <a href="javascript:;">
            <img src="http://img.linekong.com/lk_edt/2018/08/06/n141000004261664.jpg" alt="">
            <h3>蓝港游戏CEO陈浩：慢下来，做一家有趣的研发公司</h3>
            <p>8月3日，2018中国国际数字娱乐产业大会在上海举办，蓝港游戏CEO陈浩在会上发表了《慢下来，做一家有趣的研发公司》的主题演讲。尽管国内游戏市场变得越来越难做，但在陈浩看来，这恰恰是长跑的开始。当行业褪去浮躁，只要坚持用心做好产品，市场必有回响，这也是蓝港游戏一直坚持的信念。</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="contact_us content_box column_box" id="contactUs">
      <div class="con_tle">联系我们</div>
      <div class="contact_img"></div>
    </div>
    <div class="footer">
      <p>手游通（北京)科技有限公司 | 证书编号：京ICP证110843号 | <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2020037566号-1</a></p>
    </div>
    <div id="ewm" v-show="ewm" @click="hideewm">
      <img src="../../static/img/ewm.png" alt=""></div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      ewm: false
    }
  },
  methods: {
    showewm: function () {
      this.ewm = true
    },
    hideewm: function () {
      this.ewm = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top_box {position:fixed;top:0;background:#000;width: 100%;height:60px;box-shadow: 0 2px 14px 0 rgba(20, 111, 189, 0.17);-webkit-box-shadow: 0 2px 14px 0 rgba(20, 111, 189, 0.17);z-index: 1;}
.top_nav {margin: 0 auto;width: 1000px;height: 60px;}
.top_nav a {display: inline-block;width: 110px;text-align: center;line-height: 70px;color:#fff;}
.top_nav .logo {float:left;margin-right:50px;width: 208px;height: 63px;background: url(../../static/img/syt_logo.png) no-repeat center;background-size: 75%;}
.content_box {margin:0 auto;padding:30px 0 0;width: 1000px;margin-top:60px;height:auto;overflow: hidden;}
.content_box .con_tle {font-size: 18px;background: #f7f7f7;padding: 10px 20px;border-radius: 5px 5px 0 0;border-bottom: 1px solid #eaeaea;}
.con_lists li {float: left;width: 498px;height:150px;padding:30px 16px;margin-right: 1px;margin-bottom:1px;background: #fff;}
.con_lists li a {display:block;}
.con_lists li a img {float: left;width: 140px;height:94px;margin-right: 10px;}
.con_lists li h3 {margin-bottom:4px;font-size: 15px;font-weight: bold;color: #555;}
.con_lists li p {font-size: 14px;color: #999;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;}
.column_box {margin-top: 0;padding: 0;}
.column_box li {width: 100%;padding: 20px;height: 160px;}
.column_box li a img {width: 180px;height: 120px;}
.column_box li h3 {font-size: 16px;margin-bottom: 10px;}
#ewm {width:100%;height:100%;background: rgba(0,0,0,0.2);position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 2;}
#ewm img {display: block;margin: 250px auto;}
.contact_us .contact_img {width: 1000px;height:655px;margin: 0 auto;background: url(../../static/img/scontact_img.jpg) no-repeat center;}
.footer {width: 100%;height: 80px;background: #000;color: #fff;text-align: center;margin-top: 50px;}
.footer p,.footer a {line-height: 80px;color: #fff;}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue